import React from 'react';

/**
 * NextButtonIcon — the "designed" next-button glyph (TT-1139).
 *
 * A thick, round-capped white chevron used by the no-cursor and tap-to-read
 * next buttons in place of the previously typed ">" (greater-than) character,
 * so the button carries no typography. Purely decorative: the parent <button>
 * owns the accessible label, so this is hidden from assistive tech. The stroke
 * uses currentColor and inherits the button's color.
 *
 * The explicit width/height give the SVG an intrinsic size so `width: auto` in
 * .phraseNextButtonIcon resolves via the aspect ratio; without them some WebKit
 * (iOS Safari) versions collapse a viewBox-only SVG to zero width. CSS still wins
 * where it applies.
 */
export default function NextButtonIcon() {
  return (
    <svg
      className="phraseNextButtonIcon"
      viewBox="0 0 32 32"
      width="32"
      height="32"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M12 7 L21 16 L12 25"
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
